module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-3d-e40513d698378206d41fd8861a9a69a9.svg";